import React, {useEffect, useRef, useState} from "react";


const Avatar = props => {
    const {
        name,
        src,
        height = 110,
        children,
        style,
        transition = true,
        onAvatarClick,
        ...restProps
    } = props;

    const fontSize = Math.floor(height * .3);
    const [showAvatar, setShowAvatar] = useState(false);
    const tempImage = useRef(new Image());
    useEffect(() => {
        if (src != null && src !== "") {
            const temp = tempImage.current;
            temp.src = src;
            temp.onload = () => {
                setShowAvatar(true);
            }
        }
    }, [src]);

    useEffect(() => {
        return () => {
            tempImage.current.onload = null;
        }
    }, []);

    return (
        <div
            style={{
                height,
                width: height,
                borderRadius: "50%",
                overflow: "hidden",
                position: "relative",
                ...style,
            }}
        >
            {
                showAvatar
                    ? <img onClick={() => onAvatarClick?.(src)} src={src} style={{cursor: onAvatarClick ? "pointer" : "default", height: "100%", width: "100%"}} className={transition ? "fade-in-img" : ""} />
                    : (
                        <span
                            style={{
                                width: "100%",
                                height: "100%",
                                backgroundColor: "#568AAD",
                                color: "#FFF",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                fontSize: fontSize,
                            }}
                        >
                            {name?.slice(-2)}
                        </span>
                    )
            }
            {children}
        </div>
    )
}


export default Avatar;
